module.exports = __webpack_public_path__ + "static/img/shopping-cart-on.921b6a3b.png";